import { Action, createReducer, on } from '@ngrx/store';
import * as PowerBiActions from './powerbi.actions';
import * as PowerBiFeatureState from './powerbi.state';

const powerBiReducer = createReducer<PowerBiFeatureState.PowerBiState>(
  PowerBiFeatureState.initialPowerBiState,

  on(PowerBiActions.getEmbedConfig, (state) => ({
    ...state,
    error: null,
  })),

  on(PowerBiActions.getEmbedConfigSuccess, (state, { embedConfig }) => ({
    ...state,
    error: null,
    reports: {
      analytics: {
        id: embedConfig.id,
        embedUrl: embedConfig.embedUrl,
        embedToken: embedConfig.embedToken,
      },
    },
  })),

  on(PowerBiActions.getEmbedConfigFailure, (state) => ({
    ...state,
    error:
      "We couldn't load the analytics dashboard. Please try again or contact support if the problem continues.",
  }))
);

export function reducer(
  state: PowerBiFeatureState.PowerBiState | undefined,
  action: Action
) {
  return powerBiReducer(state, action);
}
